/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'

interface ConditionalFieldProps {
  name?: string
  watchName: string
  when: (value: any) => boolean
  children: React.ReactNode
}

function ConditionalField({
  name,
  watchName,
  when,
  children
}: ConditionalFieldProps) {
  const { unregister, clearErrors } = useFormContext()
  const watchedValue = useWatch({ name: watchName })
  const isVisible = when(watchedValue)

  useEffect(() => {
    if (!isVisible && name) {
      unregister(name, { keepDefaultValue: false })
      clearErrors(name)
    }
  }, [clearErrors, isVisible, name, unregister])

  return isVisible ? <>{children}</> : null
}

export default ConditionalField
